export function appendQueryParams(path, params) {
    if (!params || typeof params !== 'object') {
        return path;
    }

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
            return;
        }

        searchParams.append(key, String(value));
    });

    const queryString = searchParams.toString();

    return queryString ? `${path}?${queryString}` : path;
}
